import React from 'react';

import Answer from './Answer/Answer';

import './Answers.scss';    

const Answers = props => {
    return (
        <div className="Answers">
            <form>
                {(props.answers.map((answer, i) =>
                    <Answer
                        answer={answer}
                        key={`Answer--${i}`}
                        pnlIdx={props.pnlIdx}
                        ansIdx={i}
                        type={props.type}
                        value={(props.type === 'checkbox') ? 
                            100/props.answers.length : 
                            100/props.answers.length * (i+1)
                        }
                    />
                ))}
            </form>
        </div>
    );
}

export default Answers;